import { authClient, baseClient, getServiceURL, getURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'
import { ApiCaller } from '@front/utils'
import { getServiceURLserverSide } from '@infrastructure/Urls'

const getAccountDetails = async () => {
	if (Toggles.isEnabled('getUserByCrmIdV3')) {
		const data = await ApiCaller.call('v3', 'GET', 'account', null, { credentials: 'include' })
		return { data }
	} else {

		let response = await authClient.get(`${getServiceURL('users')}/v1/account`)
		let data
		const crmId = response.data.crm?.contact?.id
		const email = response.data?.email
	
		if (crmId) {
			data = await ApiCaller.call('v2', "GET", `user/${crmId}`, null, { credentials: "include" })
		} else if (email) {
			data = await ApiCaller.call('v2', "GET", `user/email/${email}`, null, { credentials: "include" })
		}
		response = { data }
	
		return response
	}

}

const refreshToken = () => {
	// Same toggle gate as `UserApi.refreshUser` and `authClient.authMiddleware`.
	// Keeping the three call sites aligned is what stops sr-users from
	// silently re-scoping the `vibia_refresh` cookie to `/users/v1/auth/refresh`
	// and breaking the next v3 refresh after a page reload (DV-5930).
	const useV3 = Toggles.isEnabled('authenticateUserV3')
	const url = useV3
		? getURL('/v3/auth/refresh', 'api')
		: `${getServiceURL('users')}/v1/auth/refresh`
	return authClient.post(url)
}

const doLogout = () => {
	if (Toggles.isEnabled('logoutv3')) {
		return authClient.post(`${getServiceURLserverSide('v3')}/logout`)
	} else {
		return authClient.post(`${getServiceURL('users')}/v1/auth/logout`)
	}
}

const checkEmailExists = (email) => {
	return baseClient
		.get(`${getServiceURL('users')}/v1/users/email-validate/${email}`)
		.then(() => ({
			data: true,
			status: 200
		}))
		.catch((error) => {
			if (error.response.status === 404) {
				return {
					data: false,
					status: 404
				}
			}
			return error
		})
}

export default {
	getAccountDetails,
	refreshToken,
	doLogout,
	checkEmailExists
}
